import { useFormContext } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import Body from 'storybookConfig/stories/molecules/Body';
import CommerceTypeDecisionButton from 'storybookConfig/stories/molecules/Button/DecisionButton/CommerceTypeDecisionButton';
import PrimaryButton from 'storybookConfig/stories/molecules/Button/PrimaryButton';
import TertiaryButton from 'storybookConfig/stories/molecules/Button/TertiaryButton';
import Heading from 'storybookConfig/stories/molecules/Heading';
import Link from 'storybookConfig/stories/molecules/Link';
import SupportLink from 'storybookConfig/stories/molecules/Link/SupportLink';
import ProgressBar from 'storybookConfig/stories/organisms/ProgressBar';
import { CommerceType } from 'types/models/company';
import { ButtonGrid, FooterRow, HeaderContent, SectionContent, StepContent } from './Shared.styles';

interface CommerceTypeSelectionProps {
  currentStep: number;
  totalSteps: number;
  onNextButtonClick: () => void;
}

const CommerceTypeSelection = ({
  currentStep,
  totalSteps,
  onNextButtonClick,
}: CommerceTypeSelectionProps) => {
  const location = useLocation();
  const { setValue, watch } = useFormContext();

  const isCreatingAnotherCompany = !!location.state?.isCreatingAnotherCompany;
  const commerceType = watch('commerceType');

  return (
    <StepContent>
      <ProgressBar totalSteps={totalSteps} completedSteps={currentStep} stepLabel="Commerce Type" />

      <SectionContent>
        <HeaderContent>
          <Heading variant="Headings/H3" as="h1">
            How do you want to use Carro?
          </Heading>

          <Body as="p">
            Please choose a commerce type. Your commerce type can only be changed later under
            certain conditions. Please choose the one that aligns best with your company&apos;s
            objective.{' '}
            <SupportLink article="/account-management/how-to-change-your-commerce-type">
              Learn more
            </SupportLink>
          </Body>
        </HeaderContent>

        <ButtonGrid>
          <CommerceTypeDecisionButton
            variant={CommerceType.Seller}
            isActive={commerceType === CommerceType.Seller}
            onClick={() => setValue('commerceType', CommerceType.Seller)}
          />

          <CommerceTypeDecisionButton
            variant={CommerceType.Buyer}
            isActive={commerceType === CommerceType.Buyer}
            onClick={() => setValue('commerceType', CommerceType.Buyer)}
          />
        </ButtonGrid>

        <FooterRow>
          <TertiaryButton
            $iconName={isCreatingAnotherCompany ? 'navigate_before' : undefined}
            $removePadding="left"
            as={Link}
            to={isCreatingAnotherCompany ? '/' : '/logout'}
          >
            {isCreatingAnotherCompany ? 'Back' : 'Log out'}
          </TertiaryButton>

          <PrimaryButton $iconName="navigate_next" $iconAfter onClick={onNextButtonClick}>
            Next
          </PrimaryButton>
        </FooterRow>
      </SectionContent>
    </StepContent>
  );
};

export default CommerceTypeSelection;
